<template>
    <div class="plugin-home-tabs-text-item">
        <div>
            {{ text }}
        </div>
        <plugin-home-common-arrow-link
            v-bind:text="buttonText"
            v-bind:url="buttonUrl"
            theme="primary"
        />
    </div>
</template>

<script>
// import utils from '~/utils';

export default {
    name: 'plugin-home-tabs-text-item',
    props: {
        text: {
            type: String,
            default: '',
        },
        buttonText: {
            type: String,
            default: '',
        },
        buttonUrl: {
            type: String,
            default: '',
        },
    },
    data: () => ({

    }),
    methods: {

    },
    mounted() {

    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-home-tabs-text-item {
    .typography-medium();

    display: flex;
    flex-direction: column;
    gap: 12px;

    padding: 24px 0;

    @media @media-md-down {
        .typography-heading();

        padding: 12px 0;
    }
}
</style>
